import { useState } from 'react'
import { Box, Typography, Paper, Tabs, Tab } from '@mui/material'
import { CreditCard, Receipt, Storefront, CardGiftcard } from '@mui/icons-material'
import { CurrentPlanSection } from '../components/CurrentPlanSection'
import { PlanComparisonSection } from '../components/PlanComparisonSection'
import { BillingHistorySection } from '../components/BillingHistorySection'
import { CreditsSection } from '../components/CreditsSection'

export default function SubscriptionPage() {
  const [activeTab, setActiveTab] = useState(0)

  const scrollToPlans = () => {
    setActiveTab(1) // Switch to Plans tab
  }

  const tabs = [
    {
      label: 'Current Plan',
      icon: <CreditCard />,
      component: <CurrentPlanSection onUpgradeClick={scrollToPlans} />,
    },
    { label: 'Plans', icon: <Storefront />, component: <PlanComparisonSection /> },
    { label: 'Credits', icon: <CardGiftcard />, component: <CreditsSection /> },
    { label: 'Billing History', icon: <Receipt />, component: <BillingHistorySection /> },
  ]

  return (
    <Box>
      {/* Header */}
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
        Subscription
      </Typography>

      {/* Tabs */}
      <Paper elevation={0} sx={{ mb: 3, border: '1px solid', borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs.map((tab, index) => (
            <Tab key={index} icon={tab.icon} label={tab.label} iconPosition="start" />
          ))}
        </Tabs>
      </Paper>

      {/* Tab Content */}
      <Box>{tabs[activeTab].component}</Box>
    </Box>
  )
}
